const $464043560413cad2$var$between = (value, lowerBound, upperBound, option = 'include')=>option === 'include' ? lowerBound <= value && value <= upperBound : option === 'exclude' ? lowerBound < value && value < upperBound : option === 'exclude-lower' || option === 'include-upper' ? lowerBound < value && value <= upperBound : option === 'include-lower' || option === 'exclude-upper' ? lowerBound <= value && value < upperBound : null
;
var $464043560413cad2$export$2e2bcd8739ae039 = $464043560413cad2$var$between;


const $dd0eb88eca45df5e$var$either = (value, ...comparisons)=>comparisons.includes(value)
;
var $dd0eb88eca45df5e$export$2e2bcd8739ae039 = $dd0eb88eca45df5e$var$either;


const $9513d0a973d565a8$var$exists = (value)=>value != null
;
var $9513d0a973d565a8$export$2e2bcd8739ae039 = $9513d0a973d565a8$var$exists;


const $49ae894e815eaa09$var$defined = (value)=>value !== undefined
;
var $49ae894e815eaa09$export$2e2bcd8739ae039 = $49ae894e815eaa09$var$defined;


const $d8031f55a8866c54$var$wait = (ms = 1000)=>new Promise((_)=>setTimeout(_, ms)
    )
;
var $d8031f55a8866c54$export$2e2bcd8739ae039 = $d8031f55a8866c54$var$wait;




export {$464043560413cad2$export$2e2bcd8739ae039 as between, $dd0eb88eca45df5e$export$2e2bcd8739ae039 as either, $9513d0a973d565a8$export$2e2bcd8739ae039 as exists, $49ae894e815eaa09$export$2e2bcd8739ae039 as defined, $d8031f55a8866c54$export$2e2bcd8739ae039 as wait};
//# sourceMappingURL=module.js.map
